import { Component } from 'opus-angular-seed-core';
import template from './template.html';
import { buildComparisonHtml } from '../../../../../../services/htmlContent';
import { translateWithLanguage } from '../translationState';

const MEDIA_ICONS = {
    image: 'ico-preview',
    video: 'ico-video',
    audio: 'ico-audio'
};

const MEDIA_LABELS = {
    image: 'authoringTool.Image',
    video: 'authoringTool.Video',
    audio: 'authoringTool.Audio'
};

/**
 * Read-only source language chapter shown next to the edited translation.
 *
 * The source chapter is shown with its formatting, only the media is replaced by lightweight
 * placeholders. Nothing of it is ever copied into the edited chapter.
 */
@Component({
    bindings: {
        chapter: '<',
        language: '<'
    },
    template
})
export default class {
    constructor ($sce, $translate, COMPANY_LANGUAGE_ENUM) {
        this.$sce = $sce;
        this.$translate = $translate;
        this.COMPANY_LANGUAGE_ENUM = COMPANY_LANGUAGE_ENUM;
    }

    getLabel () {
        return translateWithLanguage(
            this.$translate,
            'authoringTool.Language source',
            this.COMPANY_LANGUAGE_ENUM.LABELS[this.language]
        );
    }

    getContent () {
        return this.$sce.trustAsHtml(this.getContentHtml());
    }

    /**
     * The result is cached for the content it was built from, so the content is only parsed again
     * when the source actually changes.
     */
    getContentHtml () {
        if (!this.chapter) {
            return '';
        }

        const content = this.chapter.content ? this.chapter.content : '';
        const cacheKey = `${this.chapter.hash}|${this.language}|${content}`;
        if (!this.contentCache || this.contentCache.key !== cacheKey) {
            this.contentCache = {
                key: cacheKey,
                html: buildComparisonHtml(content, (media, ownerDocument) => {
                    return this.createMediaPlaceholder(media, ownerDocument);
                })
            };
        }

        return this.contentCache.html;
    }

    /**
     * The texts are set as text, never as markup, so a media name can not inject any content.
     */
    createMediaPlaceholder (media, ownerDocument) {
        const placeholder = ownerDocument.createElement('span');
        placeholder.className = `material-editor__media ${this.getMediaIcon(media)}`;

        const name = ownerDocument.createElement('span');
        name.className = 'material-editor__media-name';
        name.textContent = this.getMediaName(media);
        placeholder.appendChild(name);

        const note = ownerDocument.createElement('span');
        note.className = 'material-editor__media-note';
        note.textContent = this.getMediaNote(media);
        placeholder.appendChild(note);

        return placeholder;
    }

    getMediaIcon (block) {
        return MEDIA_ICONS[block.type] ? MEDIA_ICONS[block.type] : 'ico-document';
    }

    /**
     * Only metadata that exists in the content is shown, a media element without a description
     * falls back to the name of its type instead of an invented one.
     */
    getMediaName (block) {
        if (block.name) {
            return block.name;
        }

        return this.$translate.instant(MEDIA_LABELS[block.type] ? MEDIA_LABELS[block.type] : 'authoringTool.File');
    }

    getMediaNote (block) {
        const note = translateWithLanguage(
            this.$translate,
            'authoringTool.Media is not translated',
            this.COMPANY_LANGUAGE_ENUM.LABELS[this.language]
        );

        return block.format ? `${block.format.toUpperCase()} · ${note}` : note;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/authoringTool/editor/sourcePane/index.js